import SingleFamilyHousingType from "../components/singleFamilyHousingType";
import CustomHousingType from "../components/customHousingType";
import HousingType from "../enums/housingType";
import LuxuryHousingType from "../components/luxuryHousingType";
import CondoAndTownHomesHousingType from "../components/condosAndTownHomesHousingType";
import ModelHomeHousingType from "../components/modelHomeHousingType";
import DefaultHousingType from "../components/defaultHousingType";

const housingTypeConstructors = new Map();

housingTypeConstructors.set(HousingType.SingleFamily.toString(), SingleFamilyHousingType);
housingTypeConstructors.set(HousingType.Custom.toString(), CustomHousingType);
housingTypeConstructors.set(HousingType.Luxury.toString(), LuxuryHousingType);
housingTypeConstructors.set(HousingType.CondosAndTownHomes.toString(), CondoAndTownHomesHousingType);
housingTypeConstructors.set(HousingType.ModelHomes.toString(), ModelHomeHousingType);
housingTypeConstructors.set(HousingType.DefaultHousingType.toString(), DefaultHousingType);

/**
 * Returns the class constructor to create a housing type.
 *
 * @param housingTypeName - The name of the hosuing type requested.
 */
export default (housingTypeName) => {
  const generator = housingTypeConstructors.get(housingTypeName);

  if (!generator) {
    return null;
  }

  return new generator.prototype.constructor();
};
